export const isVideoUrl = (url: string) => {
  const extension = url.split('.').pop() as string;

  const types = ['mp4', 'webm', 'wav'];
  return types.includes(extension);
};
